export class Uuid {
    reg = /\((.+?)\)/g;
    /**
     * 姓名组件获取括号内的uuid
     * @param {string}  value 金额
     */
    getUuid = (value: string = '') => {
        if (!value) return '';
        const last = (value.match(this.reg) || []).reverse()[0];
        return last ? last.substring(1, last.length - 1) : value;
    };

}

export default new Uuid();
